import { cn } from 'src/lib/utils';
import { getCategoryStyle } from './categoryStyles';
import { getCategoryIcon } from './categoryIcons';

interface CategoryBadgeProps {
  category: string | undefined;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Small colored icon badge representing a workflow step category.
 * Used in node library, step tables, and run views.
 */
export function CategoryBadge({
  category,
  size = 'sm',
  className,
}: CategoryBadgeProps) {
  const style = getCategoryStyle(category);
  const Icon = getCategoryIcon(category);
  const iconSize = size === 'md' ? 'w-4 h-4' : 'w-3.5 h-3.5';
  const padding = size === 'md' ? 'p-1' : 'p-0.5';

  return (
    <span
      className={cn(padding, 'rounded flex-shrink-0', style.badge, className)}
    >
      <Icon className={iconSize} />
    </span>
  );
}
